var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { LeftSquareFilled, RightSquareFilled, DownloadOutlined, } from "@ant-design/icons";
import { PDFViewerContainer } from "./style";
import { Drawer, message, Button } from "antd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { useApplicationContext } from "../../context/application-context";
import { signS3Url } from "../../utils/signS3Url";
import { isMobileWidth } from "../../app-routes";
// import mammoth from "mammoth";
// import PdfViewerComponent from "../paid-doc-viewer";
// import DocViewer from "react-doc-viewer";
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
// Must match the pdfjs-dist version bundled with react-pdf (uses .mjs in v4+)
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
function GenericFileViewer(_props) {
    const { tenantSettings } = useApplicationContext();
    const colorPalette = tenantSettings.tenantConfig.colorPalette;
    const { isModalOpen, setIsModalOpen, fileUrl, candidateName, placement = "right", width = "50vw", } = _props;
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [fileType, setFileType] = useState("pdf"); // Track file type: pdf, word, or image
    // const [content, setContent] = useState("");
    const [error, setError] = useState("");
    const [pdfError, setPdfError] = useState("");
    const [usePdfFallback, setUsePdfFallback] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [signedFileUrl, setSignedFileUrl] = useState(null);
    const [isSigningFile, setIsSigningFile] = useState(false);
    const handleIframeError = () => {
        setError("Failed to load the document. Please check the URL and try again.");
    };
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPdfError(""); // Clear any previous errors
        setIsLoading(false);
    }
    function onDocumentLoadError(error) {
        console.error("PDF load error:", error);
        setIsLoading(false);
        setUsePdfFallback(true);
        // Check if it's a worker loading error
        if (error.message.includes("worker") || error.message.includes("CORS")) {
            setPdfError("PDF viewer is having trouble loading. Please try downloading the file instead.");
        }
        else {
            setPdfError("Failed to load PDF file. Please try again or download the file.");
        }
    }
    message.config({
        top: 60,
    });
    // useEffect(() => {
    //   if (fileUrl)
    //     fetch(fileUrl)
    //       .then((response) => response.arrayBuffer())
    //       .then((data) => mammoth.convertToHtml({ arrayBuffer: data }))
    //       .then((result) => setContent(result.value))
    //       .catch((err) => console.error("Error converting file:", err));
    // }, [fileUrl]);
    const getFileExtension = (url) => {
        try {
            const parsedUrl = new URL(url);
            const pathname = parsedUrl.pathname;
            const segments = pathname.split(".");
            const rawSegment = segments.pop() || "";
            const cleanedSegment = rawSegment
                .split(/[?&#_]/)[0]
                .toLowerCase()
                .trim();
            return cleanedSegment;
        }
        catch (_a) {
            const cleanUrl = url.split("?")[0];
            const segments = cleanUrl.split(".");
            const rawSegment = segments.pop() || "";
            return rawSegment.split(/[?&#_]/)[0].toLowerCase().trim();
        }
    };
    useEffect(() => {
        // Reset states when modal opens
        if (isModalOpen) {
            setPageNumber(1);
            setError("");
            setPdfError("");
            setNumPages(null);
            setIsLoading(false);
            setSignedFileUrl(null);
            setIsSigningFile(false);
            setUsePdfFallback(false);
        }
        // Check if fileUrl is valid
        if (!fileUrl || fileUrl.trim() === "") {
            setError("No file URL provided");
            return;
        }
        // Determine file type based on fileUrl extension
        let detectedType = "unknown";
        const extension = getFileExtension(fileUrl);
        if (extension === "png" || extension === "jpg" || extension === "jpeg") {
            detectedType = "image";
        }
        else if (extension === "doc" || extension === "docx") {
            detectedType = "word";
        }
        else if (extension === "pdf") {
            detectedType = "pdf";
        }
        else {
            setError("Unsupported file type");
            return;
        }
        setFileType(detectedType);
        // Sign the URL when modal opens
        if (isModalOpen && fileUrl) {
            const signFileUrl = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    setIsSigningFile(true);
                    const signedUrl = yield signS3Url(fileUrl);
                    setSignedFileUrl(signedUrl);
                }
                catch (err) {
                    console.error("Error signing file URL:", err);
                    setError("Failed to load document. Please try again.");
                }
                finally {
                    setIsSigningFile(false);
                }
            });
            signFileUrl();
        }
    }, [isModalOpen, fileUrl]);
    const onCloseDrawer = () => {
        setIsModalOpen(false);
    };
    return (_jsxs(PDFViewerContainer, { children: [_jsx(ToastContainer, {}), _jsx(Drawer, Object.assign({ width: isMobileWidth ? "100vw" : "60vw", title: _jsxs("div", Object.assign({ style: {
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                    } }, { children: [_jsx("div", Object.assign({ style: {
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: colorPalette.primaryColor,
                            } }, { children: "DOCUMENT VIEWER" })), " ", _jsx("div", { children: _jsx("a", Object.assign({ href: `${signedFileUrl || fileUrl}`, download: `resume.${fileType}` }, { children: _jsx(Button, Object.assign({ icon: _jsx(DownloadOutlined, {}), type: "primary", size: "small", style: {
                                        color: colorPalette.primaryColor,
                                        borderColor: colorPalette.primaryColor,
                                        backgroundColor: "transparent",
                                    } }, { children: "Download" })) })) })] })), onClose: onCloseDrawer, destroyOnClose: true, open: isModalOpen, placement: placement, style: {
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1001,
                    padding: "0px 24px",
                } }, { children: isSigningFile ? (_jsx("div", Object.assign({ style: { padding: "20px", textAlign: "center" } }, { children: "Loading document..." }))) : fileType === "pdf" ? (_jsxs("div", Object.assign({ style: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    } }, { children: [_jsxs("div", Object.assign({ className: "page-controls-viewer" }, { children: [_jsx("button", Object.assign({ style: { cursor: "pointer" }, onClick: () => setPageNumber(Math.max(pageNumber - 1, 1)) }, { children: _jsx(LeftSquareFilled, {}) })), _jsxs("span", Object.assign({ style: { margin: "10px" } }, { children: ["Page ", pageNumber, " of ", numPages] })), _jsx("button", Object.assign({ style: { cursor: "pointer" }, onClick: () => setPageNumber(Math.min(pageNumber + 1, numPages || 1)) }, { children: _jsx(RightSquareFilled, { style: { cursor: "pointer" } }) }))] })), pdfError || usePdfFallback ? (_jsxs("div", Object.assign({ style: { textAlign: "center", padding: "20px" } }, { children: [pdfError && (_jsx("div", Object.assign({ style: { color: "red", marginBottom: "15px" } }, { children: pdfError }))), usePdfFallback ? (_jsx("iframe", { src: signedFileUrl || fileUrl, width: "100%", height: "600px", style: { border: "none" }, onError: handleIframeError })) : (_jsx("a", Object.assign({ href: `${signedFileUrl || fileUrl}`, download: `resume.${fileType}` }, { children: _jsx(Button, Object.assign({ icon: _jsx(DownloadOutlined, {}), type: "primary", size: "small", style: {
                                            color: colorPalette.primaryColor,
                                            borderColor: colorPalette.primaryColor,
                                            backgroundColor: "transparent",
                                        } }, { children: "Download PDF" })) })))] }))) : (_jsx(Document, Object.assign({ file: signedFileUrl || fileUrl, onLoadSuccess: onDocumentLoadSuccess, onLoadError: onDocumentLoadError, onLoadProgress: () => setIsLoading(true), loading: _jsx("div", Object.assign({ style: { padding: "20px", textAlign: "center" } }, { children: "Loading PDF..." })) }, { children: _jsx(Page, { pageNumber: pageNumber, loading: _jsxs("div", Object.assign({ style: { padding: "20px", textAlign: "center" } }, { children: ["Loading page ", pageNumber, "..."] })) }) })))] }))) : fileType === "word" && (signedFileUrl || fileUrl) ? (_jsx(_Fragment, { children: error ? (_jsxs("div", Object.assign({ style: { textAlign: "center", padding: "20px" } }, { children: [_jsx("div", Object.assign({ style: { color: "red", marginBottom: "15px" } }, { children: error })), _jsx("a", Object.assign({ href: `${signedFileUrl || fileUrl}`, download: `resume.${fileType}` }, { children: _jsx(Button, Object.assign({ icon: _jsx(DownloadOutlined, {}), type: "primary", size: "small", style: {
                                        color: colorPalette.primaryColor,
                                        borderColor: colorPalette.primaryColor,
                                        backgroundColor: "transparent",
                                    } }, { children: "Download Document" })) }))] }))) : (_jsx("iframe", { src: `https://view.officeapps.live.com/op/embed.aspx?src=${signedFileUrl ||
                            fileUrl}`, width: "100%", height: "600px", frameBorder: "0", onLoad: () => setError(""), onError: handleIframeError })) })) : fileType === "image" && (signedFileUrl || fileUrl) ? (_jsx("div", Object.assign({ style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                    } }, { children: _jsx("img", { src: signedFileUrl || fileUrl, alt: "Supporting Document", style: {
                            maxWidth: "100%",
                            maxHeight: "80vh",
                            objectFit: "contain",
                        }, onError: () => setError("Unable to load image. Please download it instead.") }) }))) : (
                // <>
                //   <h3>Please download to view the file</h3>
                //   <div>
                //     <a href={`${fileUrl}`} download={`resume.${fileType}`}>
                //       <Button icon={<DownloadOutlined />} type="primary" size="small">
                //         Download
                //       </Button>
                //     </a>
                //   </div>
                // </>
                _jsx("p", { children: "Error: Unsupported file type" })) }))] }));
}
export default GenericFileViewer;
